<template>
	<div>
		<ValidationObserver ref="formModalValidate">
			<b-row>
				<b-col cols="12" md="4" lg="3">
					<ValidationProvider name="code" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('course_code')">
							<b-form-input type="text" v-model="formData.code" :state="errors[0] ? false : null" />
							<b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="8" lg="9">
					<b-form-group :label="$t('name')">
						<ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
							<b-input-group class="mb-1">
								<b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
							</b-input-group>
							<b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2" />
						</ValidationProvider>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<ValidationProvider name="credit" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('credit')">
							<b-form-input type="number" v-model="formData.credit" :state="errors[0] ? false : null" />
							<b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col>
					<ValidationProvider name="grading_system_id" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('grade_scala')">
							<grade-system-selectbox v-model="formData.grading_system_id" :validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" md="4">
					<ValidationProvider name="faculty_code" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('faculty')">
							<faculty-selectbox v-model="formData.faculty_code" :validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="4">
					<ValidationProvider name="department_code" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('department')">
							<department-selectbox v-model="formData.department_code" :faculty_code="formData.faculty_code"
								:validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="4">
					<ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('program')">
							<program-selectbox v-model="formData.program_code" :faculty_code="formData.faculty_code"
								:department_code="formData.department_code" :validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" md="4">
					<ValidationProvider name="type" rules="" v-slot="{ valid, errors }">
						<b-form-group :label="$t('course_type')">
							<parameter-selectbox v-model="formData.type" :code="'course_types'"
								:validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="4">
					<ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('course_status')">
							<status-selectbox v-model="formData.status" :validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
                <b-col>
                    <ValidationProvider name="update_type" v-slot="{ errors }">
                        <b-form-group :label="$t('course_update_type')">
                            <multi-selectbox v-model="formData.update_type"
                                             :options="courseUpdateOptions"
                                             :multiple="false"
                                             :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="equivalent_course_id" rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('course')">
                            <course-auto-complete v-model="formData.equivalent_course_id" :valueObject="courseValueObject"></course-auto-complete>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
			</b-row>
            <b-row v-if="formData.update_type == 4">
                <b-col>
                    <ValidationProvider name="number" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('student_numbers')">
                            <lined-textarea v-model="formData.student_numbers"
                                            :nowrap="false"
                                            :disabled="false"
                                            :styles="{ height: '5em', resize: 'both' }"
                                            :validateError="errors[0]">
                            </lined-textarea>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-row v-if="formData.update_type == 5">
                <b-col>
                    <ValidationProvider name="registration_semester_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('registration_semester')">
                            <semesters-selectbox
                                v-model="formData.registration_semester_id"
                                :validate-error="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
				<b-button variant="primary" @click="updateForm" :disabled="formLoading">
					{{ $t('save') }}
				</b-button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
// Components
import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import GradeSystemSelectbox from "@/components/interactive-fields/GradeSystemSelectbox";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import LinedTextarea from "@/components/elements/LinedTextarea.vue"
import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete";

// Services
import CourseService from "@/services/CourseService";

// Other
import { ValidationProvider, ValidationObserver } from "vee-validate"

export default {
	components: {
		DepartmentSelectbox,
		FacultySelectbox,
		GradeSystemSelectbox,
		ParameterSelectbox,
		ProgramSelectbox,
		StatusSelectbox,
        MultiSelectbox,
        LinedTextarea,
        CourseAutoComplete,

		ValidationProvider,
		ValidationObserver,
	},
	props: {
		formId: {
			type: Number,
		}
	},
	data() {
		return {
			formData: {
				code: null,
				name: null,
				credit: null,
				grading_system_id: null,
				faculty_code: null,
				department_code: null,
				program_code: null,
				type: null,
				status: null,
                update_type: null,
                registration_semester_id: null,
                equivalent_course_id: null,
                equivalent_course_code: null,
                equivalent_course_name: null,
			},
			coordinatorValue: {},
			formLoading: false,
            courseUpdateOptions: [
                {
                    text: this.$t('course_update_option_1'),
                    value: 1
                },
                {
                    text: this.$t('course_update_option_2'),
                    value: 2
                },
                {
                    text: this.$t('course_update_option_3'),
                    value: 3
                },
                {
                    text: this.$t('student_numbers'),
                    value: 4
                },
                {
                    text: this.$t('registration_semester'),
                    value: 5
                }
            ],
            courseValueObject: {},
		}
	},
	watch: {
		formId: function (val) {
			this.get(val)
		}
	},
	async created() {
		await this.get(this.formId)
	},
	methods: {
		get(id) {
			CourseService.get(id)
				.then(response => {
					let data = response.data.data;
					this.formData = {
						code: data.code,
						name: this.decodeHtml(data.name),
						credit: data.credit,
						grading_system_id: data.grading_system_id,
						faculty_code: data.faculty_code,
						department_code: data.department_code,
						program_code: data.program_code,
						type: data.type,
						status: data.status,
                        update_type: data.update_type,
                        equivalent_course_id: data.equivalent_course_id,
					}
                    this.courseValueObject = {
                        value: data.equivalent_course_id,
                        text: data.equivalent_course_name + ' - ' + data.equivalent_course_code
                    }

				})
				.catch(e => {
					this.showErrors(e)
				})
		},

		async updateForm() {
			if (this.checkPermission('course_update')) {
				const isValid = await this.$refs.formModalValidate.validate();
				if (isValid && this.formId) {
					this.formLoading = true;
                    if (this.formData.student_numbers) {
                        this.formData.student_numbers = this.formData.student_numbers.split(/\n/)
                    }
					CourseService.update(this.formId, this.formData)
						.then(response => {
							this.$emit('updateFormSuccess', true);
							this.$toast.success(this.$t('api.' + response.data.message));
						})
						.catch(e => {
							this.showErrors(e, this.$refs.formModalValidate);
						})
						.finally(() => {
							this.formLoading = false
						})
				}
			} else {
				this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
			}
		}
	}
}
</script>
